import { Reveal } from "@/components/common/Reveal";
import { HERO_VIDEO } from "@/utils/constants";

export const VideoSection = () => (
  <section id="video" data-testid="video-section" className="relative min-h-[70vh] flex items-center justify-center overflow-hidden">
    <video
      data-testid="showcase-video"
      className="absolute inset-0 w-full h-full object-cover"
      src={HERO_VIDEO.src}
      poster={HERO_VIDEO.poster}
      autoPlay
      muted
      loop
      playsInline
      preload="metadata"
    />
    <div className="absolute inset-0 bg-ink/65" />
    <div className="absolute inset-0" style={{ background: "radial-gradient(circle at 50% 50%, rgba(107,255,61,0.10), transparent 60%)" }} />

    <Reveal className="relative z-10 text-center px-5">
      <h2 className="font-display text-6xl md:text-8xl text-white leading-none">
        Real Work. <span className="text-weld-glow text-glow">Real Results.</span>
      </h2>
      <p className="text-white/70 mt-4 max-w-2xl mx-auto">
        See Deuce's delivering professional mobile welding and fabrication.
      </p>
    </Reveal>
  </section>
);
